import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { ACCESS_TOKEN, REFRESH_TOKEN } from '../constants'

import { AuthState, User } from './types'

const initialState: AuthState = {
  token: localStorage.getItem(ACCESS_TOKEN),
  refreshToken: localStorage.getItem(REFRESH_TOKEN),
  currentUser: null as User | null,
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAccessToken(state, action) {
      state.token = action.payload
      localStorage.setItem(ACCESS_TOKEN, action.payload)
    },
    setRefreshToken(state, action) {
      state.refreshToken = action.payload
      localStorage.setItem(REFRESH_TOKEN, action.payload)
    },
    clearTokens(state) {
      state.token = null
      state.refreshToken = null
      localStorage.removeItem(ACCESS_TOKEN)
      localStorage.removeItem(REFRESH_TOKEN)
    },
    setCurrentUser: (state, action: PayloadAction<User | null>) => {
      state.currentUser = action.payload
    },
  },
})

const authSliceReducer = authSlice.reducer

export const { setAccessToken, setRefreshToken, clearTokens, setCurrentUser } = authSlice.actions
export default authSliceReducer
